<template>
  <div id="article-list">
    <header>
      <span class="totalArt">{{updateTotalArt}}份速记</span>
      <span>
        <span class="cancelDel" @click="cancelDelete" v-if="isMore && isCancel">取消</span>
        <span class="moreArt" @click="moreFn">{{more}}</span>
      </span>
    </header>
    <ul>
      <li
        v-for="(item, hash) in titleMap"
        :key="`${item.articleId}-${item.lastEditTime}`"
        :class="{ 'current' : currentArticleId === item.articleId && isEditOld === true}"
        @click.self.stop="edit(item.articleId)"
      >
        <label :for="hash" @click.stop="edit(item.articleId)">
          <div>
            <div class="article-title">
              <div class="label" v-if="isMore">
                <input type="checkbox" v-model="choiceList" :value="{ articleId: item.articleId, title: item.title }" :id="hash" style="display: none">
                <label :for="hash"></label>
              </div>
              <div>{{item.title}}</div>
            </div>
            <div class="last-edit-time">
              <span>{{getFormattingDate(item.lastEditTime,false)}}</span>
              <div v-if="!isMore">
                <button class="edit-btn">
                  <Icon :type="`${theme}-edit`"></Icon>
                </button>
                <button class="download-btn" @click.stop="downloadArticles(item.articleId, item.title)">
                  <Icon class="blur" :type="`${theme}-download`"></Icon>
                  <Icon class="hover" :type="`${theme}-downloadSel`"></Icon>
                </button>
                <button class="rubbish-btn" @click.stop="deleteArticles(item.articleId, item.title)">
                  <Icon class="blur" :type="`${theme}-rubbish`"></Icon>
                  <Icon class="hover" :type="`${theme}-rubbishSel`"></Icon>
                </button>
              </div>
            </div>
          </div>
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
// 依赖的外部类库
import {
  mapState
} from 'vuex'
// 类库
import JSZip from 'jszip'
import Icon from '../components/Icon'
import { getFormattingDate } from '../util/util.js'
export default {
  name: 'ArticlesList',
  data () {
    return {
      choiceList: [],
      downloadHover: false,
      rubbishHover: false,
      more: '多选', // 按钮的值
      isMore: false, // 是否显示多选按钮
      isCancel: false, // 是否显示取消按钮
      currentArticleId: '' // 选中文章的hash
    }
  },
  components: {
    Icon
  },
  computed: {
    ...mapState(['titleMap', 'theme']),
    updateTotalArt () { // 文章总数
      let total = 0
      for (let hash in this.titleMap) {
        if (hash) total++
      }
      return total
    }
  },
  watch: {
    titleMap (newVal) {
      this.choiceList = []
    },
    choiceList (newVal, oldVal) {
      // 监听被选中文章的列表,改变按钮
      if (newVal.length === 0 && this.isMore === true) {
        this.more = '完成'
        this.isCancel = false
      } else if (newVal.length > 0 && this.isMore === true) {
        this.more = '删除'
        this.isCancel = true
      }
    }
  },
  props: ['articleMap', 'isEditOld'],
  methods: {
    async downloadArticles (articleId, title) {
      if (articleId && title) {
        this.choiceList.push({articleId, title})
      }
      if (this.choiceList.length === 0) {
        this.$alert({ message: '请选择要下载的文档' })
        return
      }
      // 确认是否下载
      this.$emit('isPopBox', true)
      let flag = await this.$confirm({
        message: `确认下载${this.choiceList.map(titleItem => `《${titleItem.title}》`).join('、')}？`,
        btnList: [
          {
            value: false,
            text: '取消',
            className: 'btnReject'
          },
          {
            value: true,
            text: '确认',
            className: 'btnConfirm'
          }
        ]
      })
      this.$emit('isPopBox', false)
      if (!flag) {
        this.choiceList = [] // 清空选择的文章列表
        return
      }
      // 获取文章内容
      let list = await this.getArticles()

      if (list.length > 1) {
        let zip = new JSZip()

        for (let i = list.length - 1, j = 1; i >= 0; i--) { // 文章内容批量放入
          let article = list[i]

          if (!zip.file(article.title)) {
            zip.file(article.title, article.content)
          } else {
            zip.file(`${j++}-${article.title}`, article.content)
          }
        }
        let base64 = await zip.generateAsync({type: 'base64'}) // 创建zip文件，构造下载元素并自动点击

        let a = document.createElement('a')
        a.href = `data:application/zip;base64,${base64}`
        a.download = '字幕速记'
        a.click()
        a = null
      } else {
        let a = document.createElement('a')
        a.href = `data:text/plain;charset=utf-8,${list[0].content}`
        a.download = list[0].title
        a.click()
        a = null
      }
      this.choiceList = []
    },
    async deleteArticles (articleId, title) {
      if (articleId && title) {
        this.choiceList.push({articleId, title})
      }
      if (this.choiceList.length === 0) {
        this.$alert({ message: '请选择要删除的文档' })
        return
      }
      // 确认是否删除
      this.$emit('isPopBox', true)
      let flag = await this.$confirm({
        message: `确认删除${this.choiceList.map(titleItem => `《${titleItem.title}》`).join('、')}？`,
        btnList: [
          {
            value: false,
            text: '取消',
            className: 'btnReject'
          },
          {
            value: true,
            text: '确认',
            className: 'btnConfirm'
          }
        ]
      })
      this.$emit('isPopBox', false)
      if (!flag) {
        this.choiceList = [] // 清空选择的文章列表
        return
      }
      let articleIds = this.choiceList.map((ele) => ele.articleId)
      this.$socket.emit('delete', {articleIds})
      this.$socket.once('delete', (data) => {
        if (data.code === 0) {
          this.$alert({message: '删除成功'})
        }
      })
      this.choiceList = []
      if (this.currentArticleId === articleId) {
        this.currentArticleId = null
        this.edit(null)
      }
    },
    async getArticles () { // articleId{content, articleId}对象
      let list = []
      for (let i = 0; i < this.choiceList.length; i++) {
        let articleId = this.choiceList[i].articleId
        this.$socket.emit('findOne', {articleId})
        let article = await new Promise((resolve, reject) => {
          this.$socket.once('findOne', data => {
            // console.log('findOne', data)
            if (data.code === 0) {
              resolve({
                title: data.data.title,
                content: data.data.content.replace(/&nbsp;/g, '  ').split(`\n`).join('\r\n')
              })
            }
          })
        })
        list.push(article)
      }
      return list
    },
    async edit (articleId) {
      if (this.isMore) return
      this.$emit('editOld', articleId)
      this.currentArticleId = articleId
    },
    getLastTime (timeStemp) {
      let time = new Date(timeStemp).toLocaleString()
      return time
    },
    async moreFn () {
      if (this.isMore === false) { // 点击多选按钮
        this.edit(null)
        this.currentArticleId = null
        this.more = '完成'
        this.isMore = true
      } else {
        if (this.more === '完成') { // 点击完成按钮
          this.isMore = false
          this.more = '多选'
        } else if (this.more === '删除') { // 点击删除按钮
          await this.deleteArticles()
          this.isCancel = false
          this.isMore = false
          this.more = '多选'
        }
      }
    },
    getFormattingDate,
    // 点击取消按钮，取消所有选择
    cancelDelete () {
      this.choiceList = []
      this.isCancel = false
      this.isMore = false
      this.more = '多选'
    }
  }
}
</script>

<style scoped="scoped">
#article-list {
  width: 270px;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 5;
  top:0;
  left:-273px;
  border: 1px solid;
  border-right: 2px solid;
  transition: left 0.5s linear 0s;
  user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
}
#article-list>header{
  width:100%;
  height:46px;
  box-sizing: border-box;
  flex-shrink: 0;
  padding: 0 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid;
}
.totalArt{
  font-size: 12px;
  flex-flow: 0;
  flex-shrink: 0;
}
.moreArt{
  font-size: 14px;
  color: #838383;
  cursor: pointer;
}
.cancelDel{
  font-size: 14px;
  cursor: pointer;
  margin-right: 15px;
}
ul {
  flex-grow: 1;
  overflow-y: auto;
}
ul li {
  border-bottom: 1px solid;
  font-size: 16px;
  display: flex;
  cursor: pointer;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
}
ul li:hover,
ul li.current{
  background: #ff8466;
  color: #ffffff;
}
ul li:hover .article-title,
ul li:hover .last-edit-time,
ul li.current .article-title,
ul li.current .last-edit-time{
  color: #ffffff;
}
ul li:hover .edit-btn,
ul li.current .edit-btn{
  display: none;
}
ul li:hover .rubbish-btn,
ul li:hover .download-btn,
ul li.current .rubbish-btn,
ul li.current .download-btn{
  display: block;
}
ul>li>label,
ul>li>label>div{
  width:100%;
}
ul>li>label {
  padding: 20px 12px;
  cursor: pointer;
}
.label {
  width:18px;
  height:100%;
  float:left;
  position: relative;
  margin-right: 4px;
}
.label>label, div, button {
  display: inline-block;
}
.label>label {
  width: 14px;
  height: 14px;
  vertical-align: top;
  border-radius: 50%;
  border: 2px solid;
  cursor: pointer;
  position: absolute;
  top: 0px;
}
input[type="checkbox"]:checked+label:after {
  content: '';
  display: block;
  width: 4px;
  height: 9px;
  position: relative;
  left: 4px;
  top: 1px;
  transform: rotate(45deg);
  border-bottom: 2px solid;
  border-right: 2px solid;
}
div {
  overflow: hidden;
  flex-grow: 1;
}
.article-title {
  font-size: 16px;
  margin-bottom: 0px;
  height: 24px;
  width:100%;
  position: relative;
  overflow: hidden;
}
.article-title:after{
  content: '';
  display: block;
  clear: both;
}
.article-title>div:last-child {
  height: 100%;
  line-height: 18px;
  width: 204px;
  float:left;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.last-edit-time {
  display: flex;
  font-size: 12px;
  height: 23px;
  align-items: center;
  justify-content: space-between;
}
.last-edit-time>div{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.edit-btn {
  float: right;
  vertical-align: middle;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-top: 2px;
  cursor: pointer;
  position: relative;
}
.download-btn,
.rubbish-btn{
  float: right;
  vertical-align: middle;
  flex-shrink: 0;
  margin-top: 2px;
  cursor: pointer;
  position: relative;
  display: none;
}
.download-btn{
  width: 28px;
  height: 18px;
  margin-right: 14px;
}
.hover{
  display: none;
}
.download-btn:hover .blur,
.rubbish-btn:hover .blur {
  display: none
}
.download-btn:hover .hover,
.rubbish-btn:hover .hover {
  display: block;
}
.rubbish-btn{
  width: 18px;
  height: 23px;
}
/*主题变化*/
.default #article-list {
  background: #ffffff;
  border-color: #f2f2f2;
}
.default #article-list header {
  border-color:  #f2f2f2;
}
.default .totalArt {
  color: #7e7e7e;
}
.default .cancelDel,
.default .moreArt {
  color: #838383;
}
.default .article-title{
  color: #3a3a3a;
}
.default .last-edit-time{
  color: #7e7e7e;
}
.default ul li {
  border-color: #E2E1E0;
  color: #0a0a0a;
}
.default .label>label {
  border-color: rgb(135, 135, 135);
  background: white;
}
.default input[type="checkbox"]:checked+label {
  border-color: #ff7043;
}
.default input[type="checkbox"]:checked+label:after {
  border-color: #ff7043;
}

.dark #article-list {
  background: #2d2d2d;
  border-color: #3d3d3d;
}
.dark #article-list header {
  border-color: #3d3d3d;
}
.dark .totalArt {
  color: #e3e3e3;
}
.dark .cancelDel,
.dark .moreArt {
  color: #e3e3e3;
}
.dark .article-title{
  color: #e3e3e3;
}
.dark .last-edit-time{
  color: #b7b7b7;
}
.dark ul li {
  border-color: #3d3d3d;
  color: white;
}
.dark .label>label {
  border-color: white;
}
.dark input[type="checkbox"]:checked+label:after {
  border-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/ArticlesList.vue